import { IOption } from 'components/_form/Select/Select';
import { IUserFunction } from 'types/functions';
import { displayTranslatedField } from 'utilities/localizedString';

export function filterUserFunctionsByAreaIds(
  items: IUserFunction[],
  contextAreaIds: string[]
): IUserFunction[] {
  if (!contextAreaIds.length) return items;

  const context = new Set(contextAreaIds.map((id) => String(id)));

  return items.filter((item) => {
    const ids = item.area_ids;
    if (!ids?.length) return true;
    return ids.some((id) => context.has(String(id)));
  });
}

export function mapUserFunctionsToOptions(items: IUserFunction[]): IOption[] {
  return items.map((functionItem) => ({
    value: functionItem.id,
    label: displayTranslatedField(functionItem, 'name')
  }));
}
